import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementCheckVesCu } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_CHECK_VES_CU } from '@constants/queryKeys';

interface IUseQueryNetworkElementCheckCuVesReturned {
	isAvailableVesCu: boolean;
	isLoadingCheckVesCu: boolean;
}

const useQueryNetworkElementCheckVesCu = (id?: string): IUseQueryNetworkElementCheckCuVesReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_CHECK_VES_CU, id],
		queryFn: extractQueryParams(getNetworkElementCheckVesCu),
		enabled: [!!id],
		...refetchOptions,
	});

	return {
		isAvailableVesCu: data?.isAvailable || false,
		isLoadingCheckVesCu: isLoading || isFetching,
	};
};

export default useQueryNetworkElementCheckVesCu;
